<template>
  <div v-if="account.id">

    <div class="box">
      <div class="flex flex-wrap items-end justify-between border-b border-theme-200 light:border-theme-600 pb-2">
        <div class="flex flex-wrap items-center">
          <p class="text-3xl font-bold leading-none">{{ account.name }}</p>
          <div class="ml-2 leading-none border-l pl-2 border-white light:border-black">
            <p class="text-xs font-bold">Created at:</p>
            <p>
              {{ $moment(account.created_at).format(config.dateTimeFormats.display) }}
            </p>
          </div>
        </div>
        <div>
          <button
            type="button"
            class="btn btn-orange text-xs text-black"
            @click="$router.push('/administration/financial-account/edit/' + account.id)"
            v-if="hasPermission('financial-account.edit')"
          >
            <i class="fas fa-edit"></i>
            <span class="ml-1">Edit</span>
          </button>
          <button
            type="button"
            class="btn btn-red text-xs text-black ml-2"
            @click.stop="deleteAccount(account.id)"
            v-if="!account.is_default && hasPermission('financial-account.delete')"
          >
            <i class="fe-trash"></i>
            Delete
          </button>
        </div>
      </div>

      <div class="leading-tight">
        <p class="font-bold text-xs mt-4">Name:</p>
        <p class="text-xl">
          {{ account.name }}
        </p>

        <template v-if="account.description">
          <p class="font-bold text-xs mt-4">Description:</p>
          <p class="text-xl">
            {{ account.description }}
          </p>
        </template>

        <p class="font-bold text-xs mt-4">Type:</p>
        <p class="text-xl">
          {{ account.type }}
        </p>

        <p class="font-bold text-xs mt-4">Balance:</p>
        <p class="text-xl">
          {{ $formatMoney(account.balance) }}
        </p>
      </div>
    </div>

  </div>
</template>


<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      accountID: this.$route.params.accountID,
      account: {},
    }
  },
  computed: {
    ...mapGetters({
      config: 'config/config',
      hasPermission: 'user/hasPermission',
      hasAnyOfPermissions: 'user/hasAnyOfPermissions',
    })
  },
  mounted() {
    this.get()
  },
  methods: {
    deleteAccount(accountID) {
      this.$swal.fire({
        title: 'Delete account',
        text: 'Are you sure?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete'
      })
        .then((result) => {
          if (result.value) {
            // send delete
            axios.delete('financial-accounts/' + accountID)
              .then(() => {
                this.$swal.fire('Delete successful', '', 'success')
                this.$router.push('/administration/financial-account/list')
              })
          }
        })
    },
    get() {
      axios.get('financial-accounts/' + this.accountID)
        .then((response) => {
          this.account = Object.assign({}, response.data)
        })
        .catch((error) => {
          console.log(error.response)
          this.$swal.fire({
            title: 'Account not found',
            type: 'warning',
          })
        })
    },
  }
}
</script>
